import { render, staticRenderFns } from "./PromotionActivities.vue?vue&type=template&id=45ce4570&scoped=true&"
import script from "./PromotionActivities.vue?vue&type=script&lang=ts&"
export * from "./PromotionActivities.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionActivities.vue?vue&type=style&index=0&id=45ce4570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce4570",
  null
  
)

export default component.exports